// https://stackoverflow.com/questions/14122013/detect-if-an-element-is-visible-without-using-jquery
function isVisible(element) {
  return element.offsetWidth !== 0 || element.offsetHeight !== 0
}

function blur() {
  document.activeElement.blur()
}

// Similar to jQuery's `on` with a selector.
// callback will be called when the event is triggered on an element matching the selector
// and within the given scope.
function addScopedEventListener(scope, event, selector, callback) {
  scope.addEventListener(event, (e) => {
    const targetOfInterest = e.target.closest(selector)
    if (targetOfInterest && scope.contains(targetOfInterest))
      return callback(e, targetOfInterest)
  })
}

// Returns true if el1 is before el2 in the DOM
// Returns false if el1 or el2 is `null`
function isBefore(el1, el2) {
  return (
    el1 &&
    el2 &&
    (el2.compareDocumentPosition(el1) & Node.DOCUMENT_POSITION_PRECEDING) != 0
  )
}

async function imageFileToDataURL(file) {
  return new Promise((resolve) => {
    const reader = new FileReader()
    reader.onload = (readerEvent) => resolve(readerEvent.target.result)
    reader.readAsDataURL(file)
  })
}

async function dataURLtoCanvas(dataURL, options) {
  const { maxSize } = { maxSize: 800, ...options }

  return new Promise((resolve) => {
    const image = new Image()
    image.onload = function (imageEvent) {
      // Resize the image
      const canvas = document.createElement("canvas")
      var width = image.width,
        height = image.height
      if (width > height) {
        if (width > maxSize) {
          height *= maxSize / width
          width = maxSize
        }
      } else {
        if (height > maxSize) {
          width *= maxSize / height
          height = maxSize
        }
      }
      canvas.width = width
      canvas.height = height
      canvas.getContext("2d").drawImage(image, 0, 0, width, height)
      resolve(canvas)
    }
    image.src = dataURL
  })
}

async function canvasToJPEG(canvas, options) {
  const { quality } = { quality: "70%", ...options }

  return new Promise((resolve) => {
    canvas.toBlob(resolve, "image/jpeg", quality)
  })
}

export {
  isBefore,
  isVisible,
  blur,
  addScopedEventListener,
  imageFileToDataURL,
  dataURLtoCanvas,
  canvasToJPEG,
}
